import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent  {
/**
 *
 */
constructor(
  private translateService: TranslateService,
  private config: PrimeNGConfig,
) {
 
  this.translateChange('es-CL');
}


translateChange(lang: string) {
  this.translateService.use(lang);
  this.translateService
    .get("primeng")
    .subscribe((res) => {     
      this.config.setTranslation(res)});
}
}
